const TokenKey = "rock-Token";
const refeshTokenKey = "refresh-Token"
export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}
// export function getIslogin() {
//   return localStorage.getItem(LoginKey);
// }

// export function setIslogin(islogin) {
//   return localStorage.setItem('login-show', islogin);
// }
export function removeToken() {
  return localStorage.removeItem(TokenKey);
}
export function getrefeshToken() {
  return localStorage.getItem(refeshTokenKey);
}

export function setrefreshToken(token) {
  return localStorage.setItem(refeshTokenKey, token);
}
export function removerefreshToken() {
  return localStorage.removeItem(refeshTokenKey);
}
// 清空localstorage数据
export function clearStorage() {
    localStorage.clear();
}

// export function getwriter() {
//   return localStorage.getItem("writer");
// }
//
// export function setwriter(writer) {
//   return localStorage.setItem("writer", writer);
// }
//
// export function removewriter() {
//   return localStorage.removeItem("writer");
// }
/* 储存用户id */
export function getUserId() {
  return localStorage.getItem("uid");
}

export function setUserId(id) {
  return localStorage.setItem("uid", id);
}

export function removeUserId() {
  return localStorage.removeItem("uid");
}
/* 储存用户昵称 */
export function getUserName() {
    return localStorage.getItem("uname");
}

export function setUserName(uname) {
    return localStorage.setItem("uname", uname);
}

export function removeUserName() {
   return localStorage.removeItem("uname");
}
/* 储存用户头像 */
export function getUserIcon() {
    return localStorage.getItem("icon");
}
  
export function setUserIcon(icon) {
    return localStorage.setItem("icon", icon);
}

export function removeUserIcon() {
    return localStorage.removeItem("icon");
}

// export function getinfo() {
//   return localStorage.getItem("info");
// }

// export function setinfo(info) {
//   return localStorage.setItem("info", info);
// }

// export function removeinfo() {
//   return localStorage.removeItem("info");
// }
// export function getmobile() {
//   return localStorage.getItem("mobile");
// }

// export function setmobile(mobile) {
//   return localStorage.setItem("mobile", mobile);
// }

// export function removemobile() {
//   return localStorage.removeItem("mobile");
// }

/* 存储作者书的id */
// export function getAbookid() {
//   return localStorage.getItem("Abookid");
// }

// export function setAbookid(Abookid) {
//   return localStorage.setItem("Abookid", Abookid);
// }

// export function removeAbookid() {
//   return localStorage.removeItem("Abookid");
// }
/* 储存书的名字 */
export function getAbookName() {
    return localStorage.getItem("AbookName");
}
export function setAbookName(AbookName) {
    return localStorage.setItem("AbookName", AbookName);
}
export function removeAbookName() {
    return localStorage.removeItem("AbookName");
}
/* 储存书是否免费 */
export function getIsFree() {
    return localStorage.getItem("isFree");
}
export function setIsFree(free) {
    return localStorage.setItem("isFree", free);
}
export function removeIsFree() {
    return localStorage.removeItem("isFree");
}
/* 储存书第几章节 */
export function getSequence() {
    return localStorage.getItem("sequence");
}
export function setSequence(sequence) {
    return localStorage.setItem("sequence", sequence);
}
export function removeSequence() {
    return localStorage.removeItem("sequence");
}



// /* 作者的书是否可选收费 */
// export function gettoll() {
//   return localStorage.getItem("toll");
// }

// export function settoll(toll) {
//   return localStorage.setItem("toll", toll);
// }

// export function removetoll() {
//   return localStorage.removeItem("toll");
// }
// // 登录用户是否是重置密码后的第一次登录状态
// export function setIsReset(val) {
//   return localStorage.setItem("isReset", val);
// }

// export function getIsReset() {
//   return localStorage.getItem("isReset");
// }

// export function removeIsReset() {
//   return localStorage.removeItem("isReset");
// }

// export function setCookie(name, value) {
//   var Days = 30;
//   var exp = new Date();
//   exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 30);
//   document.cookie =
//     name +
//     "=" +
//     escape(value) +
//     ";expires=" +
//     exp.toGMTString() +
//     ";domain=.yuanshi.com";
// }
